module.exports = "/shared/img/hr-red-btn.png";


//////////////////
// WEBPACK FOOTER
// ./src/ui/img/hr-red-btn.png
// module id = 20
// module chunks = 13